import {
  ThemeProvider,
  theme,
  Box,
  ColorModeProvider,
  CSSReset,
} from '@chakra-ui/react'
import Header from './components/Header'
import Home from './components/Home'
import About from './components/About'
import Projects from './components/Projects'
import Contact from './components/Contact'
import Footer from './components/Footer'
import BintusStoreProjectScreen from './components/BintusStoreProjectScreen'
import BookAppProjectScreen from './components/BookAppProjectScreen'
import AfrotopiaProjectScreen from './components/AfrotopiaProjectScreen'
import { Routes, Route } from 'react-router-dom'

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <ColorModeProvider>
        <CSSReset />
        <Box className='layout'>
          <Header />
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/about' element={<About />} />
            <Route path='/projects' element={<Projects />} />
            <Route path='/contact' element={<Contact />} />
            <Route path='/bintusstore' element={<BintusStoreProjectScreen />} />
            <Route path='/bookapp' element={<BookAppProjectScreen />} />
            <Route path='/afrotopia' element={<AfrotopiaProjectScreen />} />
          </Routes>

          <Footer />
        </Box>
      </ColorModeProvider>
    </ThemeProvider>
  )
}

export default App
